window.toggleSearchBar = () => {

};
export default function initSearchMenu() {
	toggleSearchMenuVisibility();
	replaceSearchMenuText();
	adjustFirstCardBorder();
}

function replaceSearchMenuText() {
	const searchButton = document.querySelector( '.search-form .input-group-btn button ' );
	if ( searchButton ) {
		searchButton.innerText = 'Go';
	}
}

function toggleSearchMenuVisibility() {
	const searchButton = document.querySelector( '.search-button' );
	const searchMenu = document.querySelector( '#search-menu' );
	if ( searchMenu && searchButton ) {
		searchButton.onclick = () => {
			searchMenu.classList.toggle( 'd-none' );
		};
	}
}

function adjustFirstCardBorder() {
	const firstCard = document.querySelector( '.link-template-default' );
	if ( firstCard ) {
		firstCard.classList.add( 'first-card' );
	}
}
